/* Suchlupe im mobilen Header (V2, Freigabe 02.09.2026).
 *
 * Unter 990 px ersetzt die Lupe die eigene Suchzeile: Ein Tipp klappt die
 * Zeile (#HeaderSearchMobile) auf und setzt den Fokus ins Feld — die
 * Tastatur oeffnet sich, man tippt sofort. Escape schliesst und gibt den
 * Fokus an den Knopf zurueck; ein zweiter Tipp schliesst ebenfalls.
 *
 * Die Zeile selbst bleibt unveraendert die vorhandene Predictive-Search —
 * hier wird nur Sichtbarkeit und Fokus verwaltet, keine Suchlogik.
 */
class RcSearchToggle extends HTMLElement {
  connectedCallback() {
    this.knopf = this.querySelector('button');
    if (!this.knopf) return;
    this.ziel = document.getElementById(this.knopf.getAttribute('aria-controls'));
    if (!this.ziel) return;

    this.knopf.addEventListener('click', () => this.umschalten());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.offen()) {
        this.umschalten(false);
        this.knopf.focus();
      }
    });
  }

  offen() {
    return this.ziel.classList.contains('is-offen');
  }

  umschalten(soll = !this.offen()) {
    this.ziel.classList.toggle('is-offen', soll);
    this.knopf.setAttribute('aria-expanded', soll ? 'true' : 'false');
    if (soll) {
      const feld = this.ziel.querySelector('input[type="search"]');
      if (feld) feld.focus();
      if (window.rcTrack) window.rcTrack('header_search_open', { ort: 'lupe' });
    }
  }
}

customElements.define('rc-search-toggle', RcSearchToggle);
